module.exports = __webpack_public_path__ + "static/img/arrow-down-blue.9e369351.svg";